/* af1c — procedural grain overlay
 * Global shimmer: monochrome noise painted to a canvas on an interval.
 * Loaded from theme.liquid so every page (index, product, cart, collection) gets it.
 * Runs only if a canvas#grain element exists on the page.
 */
(function () {
  const grainCanvas = document.getElementById('grain');
  if (!grainCanvas) return;
  if (grainCanvas.dataset.grainInit === '1') return; // guard against double-init
  grainCanvas.dataset.grainInit = '1';

  const gctx = grainCanvas.getContext('2d', { alpha: true });
  const GRAIN_PIXEL_SIZE = 1;
  let grainW = 0, grainH = 0;

  function resizeGrain() {
    const w = Math.ceil(window.innerWidth / GRAIN_PIXEL_SIZE);
    const h = Math.ceil(window.innerHeight / GRAIN_PIXEL_SIZE);
    grainCanvas.width = w;
    grainCanvas.height = h;
    grainCanvas.style.width = window.innerWidth + 'px';
    grainCanvas.style.height = window.innerHeight + 'px';
    grainCanvas.style.imageRendering = 'pixelated';
    grainW = w;
    grainH = h;
  }

  function paintGrain() {
    const img = gctx.createImageData(grainW, grainH);
    const data = img.data;
    for (let i = 0; i < data.length; i += 4) {
      const bright = Math.random() < 0.5;
      const v = bright ? 255 : 0;
      data[i] = v;
      data[i + 1] = v;
      data[i + 2] = v;
      data[i + 3] = 60 + ((Math.random() * 90) | 0);
    }
    gctx.putImageData(img, 0, 0);
  }

  resizeGrain();
  paintGrain();

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    setInterval(paintGrain, 66);
  }

  let grainTimer;
  window.addEventListener('resize', () => {
    clearTimeout(grainTimer);
    grainTimer = setTimeout(() => { resizeGrain(); paintGrain(); }, 200);
  });
})();
